import { z } from 'zod';
import { Toast, ToastVariant, useToast } from '@hungryroot/components-toast';

const errorSchema = z.object({
  msg_id: z.string().nullable().optional(),
  detail: z.string().nullable().optional(),
});

export function useErrorMessageToasts() {
  const { toast } = useToast();

  return (e: unknown) => {
    const error = errorSchema.safeParse(e);
    if (error.data?.msg_id === 'cold_volume_exceeded') {
      toast(
        <Toast variant={ToastVariant.Critical}>
          Exceeded Cold Volume Limit
        </Toast>
      );
    }

    try {
      const detailParsed = JSON.parse(error.data?.detail || '{}');
      if (detailParsed?.pairing?.[0]?.includes('out of stock')) {
        toast(
          <Toast variant={ToastVariant.Critical}>
            One or more items are out of stock
          </Toast>
        );
      }
    } catch {
      // noop
    }
  };
}
